import { NgModule } from '@angular/core';
import { SystemAdminRoutingModule } from './system-admin-routing.module';
import { SystemAdminConfigModule } from './config/config.module';

@NgModule({
  imports: [
    SystemAdminRoutingModule,
    SystemAdminConfigModule,
  ],
})
export class SystemAdminModule {}
